import { useTranslate } from '@tolgee/react'
import { GlobalAllocationRulesViewStore } from '@yard/pages/YardSetup/stores/allocation-rules/global-allocation-rules.view-store'
import { observer } from 'mobx-react-lite'
import { AllocationRuleAccordion } from '../../../organisms/AllocationRules/AllocationRuleAccordion'

type Props = {
  globalAllocationRulesViewStore: GlobalAllocationRulesViewStore
  isEditable?: boolean
}

export const GlobalAllocationRulesAccordion = observer((props: Props) => {
  const { globalAllocationRulesViewStore, isEditable } = props
  const { t } = useTranslate()

  return (
    <AllocationRuleAccordion
      droppableId='allocationRulesList'
      title={t('globalRules', 'Global rules')}
      tooltip={t(
        'globalRulesTooltip',
        'Global rules are always working to organize your yard. These can be overridden when planning specific visits.',
      )}
      isEditable={isEditable}
      allocationRules={globalAllocationRulesViewStore.orderedAllocationRules}
      capacityByRule={globalAllocationRulesViewStore.capacityByRule}
      matchingCountByRule={globalAllocationRulesViewStore.matchingCountByRule}
      onReorder={(sourceIndex, destinationIndex) =>
        globalAllocationRulesViewStore.reorderAllocationRule(sourceIndex, destinationIndex)
      }
      hoveredIndex={globalAllocationRulesViewStore.hoveredRuleIndex}
      onHover={index => globalAllocationRulesViewStore.setHoveredRuleIndex(index)}
      onEdit={index => globalAllocationRulesViewStore.toggleFormDialog(index)}
      onDelete={index => globalAllocationRulesViewStore.deleteAllocationRule(index)}
    />
  )
})
